export const school_sections = {
    data: [
      { id: 1, name: "ابتدایی" },
      { id: 2, name: "متوسطه اول" },
      { id: 3, name: "متوسطه دوم" },
    ],
  };
  
  export const school_levels = {
    data: [
      { id: 1, name: "اول", section_id: 1 },
      { id: 2, name: "دوم", section_id: 1 },
      { id: 3, name: "سوم", section_id: 1 },
      { id: 4, name: "چهارم", section_id: 1 },
      { id: 5, name: "پنجم", section_id: 1 },
      { id: 6, name: "ششم", section_id: 1 },
      { id: 7, name: "هفتم", section_id: 2 },
      { id: 8, name: "هشتم", section_id: 2 },
      { id: 9, name: "نهم", section_id: 2 },
      { id: 10, name: "دهم", section_id: 3 },
      { id: 11, name: "یازدهم", section_id: 3 },
      { id: 12, name: "دوازدهم", section_id: 3 },
    ],
  };

  export const class_types = {
    counsel: 'مشاوره',
    solo: 'انفرادی',
    public: 'عمومی',
  }